import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, formValueSelector } from 'redux-form'
import { Button, Row, Col } from 'react-bootstrap'

import * as actions from '../../../actions'
import { FORM_ANULACION_INGRESO } from '../../../../../config/forms'

import StatusModal from
  '../../../../Forms/SharedComponents/containers/StatusModal'

class AnulacionIngreso1 extends Component {
  render () {
    const {
      numero,
      onSubmit,
      invalid,
      anulacionIngresoShowDeleteModal,
      anulacionIngresoDeleteResponse,
      onPrev,
      hideAnulacionIngresoDeleteMessageModal
    } = this.props

    return (
      <div>
        <br />
        <hr />
        <br />
        <StatusModal
          show={anulacionIngresoShowDeleteModal}
          onClick={hideAnulacionIngresoDeleteMessageModal}
          errorMessage={anulacionIngresoDeleteResponse}
          extraErrorMessage={null}
        />
        <h2>¿Está seguro de anular el ingreso de la CPE <strong>{numero}</strong>?</h2>
        <br />
        <hr />
        <br />
        <br />
        <div>
          <Row className='justify-content-md-center'>
            <Col md={12}>
              <Button onClick={() => onPrev()}
                variant='primary'
                size='lg'
              >Volver</Button>
              &nbsp;
              <Button
                size='lg'
                variant='danger'
                onClick={() => onSubmit()}
                disabled={invalid}
              >Anular CPE</Button>
            </Col>
          </Row>
        </div>
      </div>
    )
  };
};

const selector = formValueSelector(FORM_ANULACION_INGRESO)

const mapStateToProps = (state) => ({
  numero: selector(state, 'numero'),
  invalid: isInvalid(FORM_ANULACION_INGRESO)(state),
  anulacionIngresoDeleteResponse: state.camionesIngreso.anulacionIngresoDeleteResponse,
  anulacionIngresoShowDeleteModal: state.camionesIngreso.anulacionIngresoShowDeleteModal
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_ANULACION_INGRESO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(AnulacionIngreso1))
